// extracted by mini-css-extract-plugin
export var previewContainer = "_sn-0";